import React from 'react'
import styled from 'styled-components'
import EquipmentTab from '../components/EquipmentTab'

const Wrapper = styled.div`
  ${props => props.theme.layout.default};
`

interface FleetOverviewProps {}

export const FleetOverview: React.FC<FleetOverviewProps> = () => {
  return (
    <Wrapper>
      <EquipmentTab />
    </Wrapper>
  )
}
